import { BUNDLED_REFERENCE } from "./referenceData";

/** Broader-trial figure, shown in every situation. The number lives in the reference file. */
export let AI_WIN_PCT = BUNDLED_REFERENCE["ai-win-pct"].ai_win_pct;

export function installAiWinPct(doc: { ai_win_pct: number }): void {
  AI_WIN_PCT = doc.ai_win_pct;
}
